<template lang="pug">
  #stats-reporting
    BCollapse.card.mb-5.show-overflow(
      aria-id="ProgramReports"
      :open.sync="programReportsOpen"
      animation=""
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='ProgramReports'
      )
        .card-header-title
          WtTitle(card-title-large) Program Reports
        a.card-header-icon
          BIcon(:icon="programReportsOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        ProgramReports(
          :is-loading="!membersLoaded"
          :fetch-members-action="fetchProgramMembers"
          :members="membersResponseObject"
        )

    BCollapse.card.mb-5.challenge-report-card(
      aria-id="ChallengeReports"
      :open.sync="challengeReportsOpen"
      animation=""
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='ChallengeReports'
      )
        .card-header-title
          WtTitle(card-title-large) Challenge Reports
        a.card-header-icon
          BIcon(:icon="challengeReportsOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        ChallengeReports(
          :is-loading="!allChallengesLoaded"
          :challenges="nonPvsPChallenges"
        )
    BCollapse.card.mb-5.challenge-report-card(
      aria-id="QuestionReports"
      :open.sync="questionReportOpen"
      animation=""
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='QuestionReports'
      )
        .card-header-title
          WtTitle(card-title-large) Questions Reports
        a.card-header-icon
          BIcon(:icon="questionReportOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        QuestionReports(
          :is-loading="!programQuestionsLoaded"
          :program-questions="programQuestions"
          :is-core-tier="isCoreTier"
        )

    BCollapse.card.mb-5.show-overflow(
      v-if="showMentalWellnessReports"
      aria-id="MentalWellnessReports"
      :open.sync="MentalWellnessReportsOpen"
      animation=""
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='MentalWellnessReports'
      )
        .card-header-title
          WtTitle(card-title-large) Mental Wellness Reports
        a.card-header-icon
          BIcon(:icon="MentalWellnessReportsOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .column
        MentalWellnessReports(
          :is-loading="!membersLoaded"
          :fetch-members-action="fetchProgramMembers"
          :members="membersResponseObject"
        )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import ChallengeReports from "@@/Challenge/ChallengeReports";
import MentalWellnessReports from "@@/Companion/MentalWellnessReports";
import QuestionReports from "@@/Questions/QuestionReports";
import ProgramReports from "@@/Program/ProgramReports";

export default {
  name: "StatsReporting",

  components: {
    ProgramReports,
    ChallengeReports,
    QuestionReports,
    MentalWellnessReports,
    WtTitle,
    WtTile
  },

  mixins: [analyticsTrackingMixin],

  data() {
    return {
      challengeOpen: true,
      programOpen: false,
      challengeReportsOpen: true,
      programReportsOpen: true,
      programMembersPerPage: 10,
      questionReportOpen: true,
      MentalWellnessReportsOpen: true
    };
  },

  computed: {
    ...mapGetters("program", [
      "allChallenges",
      "allChallengesLoaded",
      "membersLoaded",
      "membersResponseObject",
      "programQuestions",
      "programQuestionsLoaded",
      "programSettingsCopy",
      "isCoreTier"
    ]),

    showMentalWellnessReports() {
      const isMentalWellnessEnabled = this.programSettingsCopy
        .mentalWellnessEnabled;
      return isMentalWellnessEnabled;
    },

    nonPvsPChallenges() {
      return this.allChallenges.filter(challenge => {
        return challenge.isPvsPChallenge === 0;
      });
    }
  },

  mounted() {
    this.trackFeatureView("admin", "reporting");
    const programId = this.$auth.user().programId;
    this.fetchAllChallenges({ programId });
    this.fetchProgramQuestions({ programId });
    this.fetchMembers({
      programId,
      perPage: this.programMembersPerPage
    });
  },

  methods: {
    ...mapActions("program", [
      "fetchAllChallenges",
      "fetchMembers",
      "fetchProgramQuestions"
    ]),

    fetchProgramMembers(payload) {
      Object.assign(payload, {
        programId: this.$auth.user().programId,
        perPage: this.programMembersPerPage
      });

      this.fetchMembers(payload);
    }
  }
};
</script>

<style lang="sass" scoped>
#stats-reporting
  .show-overflow
    overflow: visible
  .b-tooltip-custom
    z-index: 3 !important
  .challenge-report-card
    overflow: visible
</style>
